export default {
  signal: 'Sygnał',
  axis: 'Oś',
  color: 'Kolor',
  thickness: 'Grubość',
  stepped: 'Schodkowy',
  selectAxisPlaceholder: 'Wybierz lub utwórz oś',
  auto: 'Automatyczny',
  addSignal: 'Dodaj sygnały',
  selectSignals: 'Wybierz sygnały',
};
